export type ChatRunInfo = {
  input_id?: string;
  workflow_id?: string;
  organization_id?: string;
  settings_name_and_version?: string;
  run_attempt_id?: string;
  name?: string;
  display_id?: string;
} | null;

const fallbackRandomId = () =>
  Math.random().toString(16).slice(2) + Date.now().toString(16);

export const createChatConversationId = (): string => {
  const randomId =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : fallbackRandomId();

  return `chat-${randomId.toLowerCase()}`;
};

export const buildChatConversationScope = ({
  customerId,
  context,
  runInfo,
}: {
  customerId: string;
  context: string;
  runInfo: ChatRunInfo;
}): string =>
  [
    `customer:${customerId}`,
    `context:${context}`,
    `input:${runInfo?.input_id ?? "none"}`,
    `workflow:${runInfo?.workflow_id ?? "none"}`,
    `attempt:${runInfo?.run_attempt_id ?? "none"}`,
    `settings:${runInfo?.settings_name_and_version ?? "none"}`,
  ].join("|");
